import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { Dialog } from 'src/app/shared/models/app-models/Dialog.model';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss'],
})
export class InputDialogComponent implements OnInit {
  choices: string[] = ['Replace existing file', 'Keep both files'];
  replaceChoice: string = '';
  isReplace: boolean = false;
  constructor(
    public dialogInfoRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public input: Dialog
  ) {}

  ngOnInit(): void {}

  replaceExisingFile($event: MatRadioChange) {
    this.isReplace = $event.value == 'Keep both files' ? true : false;
  }

  close(): void {
    this.dialogInfoRef.close();
  }
  getChoice() {
    return this.isReplace;
  }
}
